import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  savingPictures: false,
  assetsUploading: 0
});

const savingWall = createReducer(getDefaultState(), {
  [Constants.savingWall.start]: (state) => ({
    ...state,
    savingPictures: true
  }),
  [Constants.savingWall.end]: (state) => ({
    ...state,
    savingPictures: false
  }),
  [Constants.savingWall.uploadAssetsStart]: (state) => ({
    ...state,
    assetsUploading: state.assetsUploading + 1
  }),
  [Constants.savingWall.uploadAssetsEnd]: (state) => ({
    ...state,
    assetsUploading: state.assetsUploading - 1
  })
});

export default savingWall;
